import * as React from 'react';
import { ReactElement } from 'react';
import { styled } from '@linaria/react';
import { SegmentedControlItem } from './SegmentedControlItem';
interface SegmentedControlProps {
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** Name of radio buttons group. Standard form field attribute */
  name: string;
  /** An onChange callback passed down by the controlling parent component */
  onChange: (value: string) => void;
  /** The value passed down by the controlling parent component */
  value: string;
  /** Segmented Control items passed as children */
  children: ReactElement[];
  /** Identify the element for selection in integration tests, FullStory, etc. */
  dataId?: string;
  /** Whether the SegmentedControl should span the whole available width */
  isFullWidth?: boolean;
}
const _exp = /*#__PURE__*/() => ({
  isFullWidth
}) => isFullWidth ? '1' : '0';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wypi3mg",
  propsAsIs: false,
  vars: {
    "wypi3mg-0": [_exp()]
  }
});
const SegmentedControl = ({
  value,
  onChange,
  name,
  children,
  dataId,
  isFullWidth = false,
  className
}: SegmentedControlProps) => {
  return <Wrapper data-id={dataId} className={className} isFullWidth={isFullWidth}>
      {React.Children.map(children, child => {
      return React.cloneElement(child, {
        ...child.props,
        name,
        value: child.props.value,
        checked: child.props.value === value,
        onChange: () => onChange(child.props.value),
        isFullWidth
      });
    })}
    </Wrapper>;
};
SegmentedControl.Item = SegmentedControlItem;
export { SegmentedControl };

require("./SegmentedControl.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SegmentedControl.tsx");